export const messagesHandler = {

    init: function () {

        let $messagesReturn = document.querySelectorAll('.message__single-return');

        Array.prototype.forEach.call($messagesReturn, ($return) => {
            let $link = $return.querySelector('a');

            $link.addEventListener('click', (e) => {
                let urlPrev = document.referrer;
                if (urlPrev && window.history.length > 1) {
                    urlPrev = new URL(urlPrev);
                    if (themeinfos.siteurl === urlPrev.origin && urlPrev.pathname.indexOf("messages") > -1 && urlPrev.pathname.indexOf("page") > -1) {
                        e.preventDefault();
                        window.history.back();
                    }
                }
            });

        })

    }

}